export default __webpack_public_path__ + "static/media/011-Taj Mahal.bb836635.svg";